// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner-wrapper {
  position: relative;
  width: 100%;
  overflow: hidden; /* Ensure the background doesn't cause scrolling */
}

.full-width-background {
  position: absolute;
  top: 0;
  left: 50%;
  width: 100vw;
  height: 235px; /* Adjust to match the height of .page-header */
  background: #448aea;
  transform: translateX(-50%);
  z-index: -1;
}

.page-header {
  position: relative;
  width: 100%;
  max-width: 1512px;
  min-height: 131px;
  height: 235px;
  color: white;
  display: flex;
  box-sizing: border-box;
  text-align: left;
  flex-direction: column; /* Stack the text vertically */
  margin: 0 auto; /* Center the header within the parent */
}

.page-header h1, .page-header p {
  color: #FFF;
}

.page-header h1 {
  position: absolute;
  font-family: Georgia, serif;
  font-size: 48px;
  font-weight: 700;
  line-height: 1.2; /* 120% */
  left: 146px;
  top: 64px;
}

.page-header p {
  position: absolute;
  color: var(--Background-color-primary, #FFF);

  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 30px */
  left: 146px;
  top: 133px;
}

.profile-image {
  position: absolute;
  right: 10px;
  top: 0px;
}

@media (max-width: 1224px) {
  /* Styles for screens that are 1500px wide or larger */
  .page-header {
    height: 131px;
  }

  .page-header h1 {
    left: 40px;
    top: 25px;
    color: #FFF;
    font-family: Georgia;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 33.6px */
  }

  .page-header p {
    position: relative;
    left: 40px;
    top: 67px;
    width: 80%;
  
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
  }

  .profile-image {
    position: absolute;
    width: 424px;
    right: 10px; /* Position the image 10px from the right */
    top: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Banner/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB,EAAE,kDAAkD;AACtE;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,YAAY;EACZ,aAAa,EAAE,+CAA+C;EAC9D,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB,EAAE,8BAA8B;EACtD,cAAc,EAAE,wCAAwC;AAC1D;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAE,SAAS;EAC3B,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;;EAE5C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,sDAAsD;EACtD;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,SAAS;IACT,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,WAAW;EAChC;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,UAAU;;IAEV,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW,EAAE,2CAA2C;IACxD,QAAQ;EACV;AACF","sourcesContent":[".banner-wrapper {\n  position: relative;\n  width: 100%;\n  overflow: hidden; /* Ensure the background doesn't cause scrolling */\n}\n\n.full-width-background {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  width: 100vw;\n  height: 235px; /* Adjust to match the height of .page-header */\n  background: #448aea;\n  transform: translateX(-50%);\n  z-index: -1;\n}\n\n.page-header {\n  position: relative;\n  width: 100%;\n  max-width: 1512px;\n  min-height: 131px;\n  height: 235px;\n  color: white;\n  display: flex;\n  box-sizing: border-box;\n  text-align: left;\n  flex-direction: column; /* Stack the text vertically */\n  margin: 0 auto; /* Center the header within the parent */\n}\n\n.page-header h1, .page-header p {\n  color: #FFF;\n}\n\n.page-header h1 {\n  position: absolute;\n  font-family: Georgia, serif;\n  font-size: 48px;\n  font-weight: 700;\n  line-height: 1.2; /* 120% */\n  left: 146px;\n  top: 64px;\n}\n\n.page-header p {\n  position: absolute;\n  color: var(--Background-color-primary, #FFF);\n\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%; /* 30px */\n  left: 146px;\n  top: 133px;\n}\n\n.profile-image {\n  position: absolute;\n  right: 10px;\n  top: 0px;\n}\n\n@media (max-width: 1224px) {\n  /* Styles for screens that are 1500px wide or larger */\n  .page-header {\n    height: 131px;\n  }\n\n  .page-header h1 {\n    left: 40px;\n    top: 25px;\n    color: #FFF;\n    font-family: Georgia;\n    font-size: 28px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 120%; /* 33.6px */\n  }\n\n  .page-header p {\n    position: relative;\n    left: 40px;\n    top: 67px;\n    width: 80%;\n  \n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n  }\n\n  .profile-image {\n    position: absolute;\n    width: 424px;\n    right: 10px; /* Position the image 10px from the right */\n    top: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
